import { render, staticRenderFns } from "./branch-form.vue?vue&type=template&id=83f9963c&scoped=true&"
import script from "./branch-form.vue?vue&type=script&lang=js&"
export * from "./branch-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83f9963c",
  null
  
)

export default component.exports